// import { message, Spin } from 'antd';
// import React from 'react';
// import {
//   FormProvider,
//   useFormContext,
//   useFieldArray,
//   useForm,
//   useWatch,
// } from 'react-hook-form';
// import { reactQueryLoadingHelper } from 'Utilities/utils';
// import { DEFAULT_ERROR_MESSAGE } from 'Utilities/constants';
// import { useEffect, useMemo } from 'react';
// import { isEmpty } from 'lodash';
// import { WhatsApp } from '@mui/icons-material';
// import Checkbox from 'Components/CommonComponents/ReactHooKForm/Checkbox/Checkbox';
// const bgColors = [
//   'bg-[#C4EEF3]',
//   'bg-[#F5DDFF]',
//   'bg-[#E9E9E9]',
//   'bg-[#FFEFD9]',
//   'bg-[#D9EFFF]',
//   'bg-[#E0FABF]',
//   'bg-[#FFEADE]',
// ];
// const subColumnColors = [
//   'bg-[#D9FBFF]',
//   'bg-[#F8E5FF]',
//   'bg-[#EEEEEE]',
//   'bg-[#FFF2D1]',
//   'bg-[#CEEAFF]',
//   'bg-[#D8FBAC]',
//   'bg-[#FFE0CF]',
// ];
// const columnContentColors = [
//   'bg-[#E9FDFF]',
//   'bg-[#FCF3FF]',
//   'bg-[#F9F9F9]',
//   'bg-[#FFF7EC]',
//   'bg-[#ECF7FF]',
//   'bg-[#F0FFDD]',
//   'bg-[#FFF3EC]',
// ];
// const CommunicationTable = ({ data }) => {
//   const { rolesArray, roleToChannelsMap } = useMemo(() => {
//     const roles = new Set();
//     const roleToChannelsMap = {};

//     data.forEach((group) => {
//       group.sidebars.forEach((sidebar) => {
//         Object.keys(sidebar).forEach((key) => {
//           if (key === 'sidebar') return;

//           roles.add(key);

//           if (!roleToChannelsMap[key]) {
//             roleToChannelsMap[key] = new Set();
//           }

//           const roleObj = sidebar[key];
//           if (roleObj && typeof roleObj === 'object') {
//             Object.keys(roleObj).forEach((channel) => {
//               roleToChannelsMap[key].add(channel);
//             });
//           }
//         });
//       });
//     });

//     const roleToChannels = {};
//     Object.entries(roleToChannelsMap).forEach(([role, channelsSet]) => {
//       roleToChannels[role] = Array.from(channelsSet);
//     });

//     return {
//       rolesArray: Array.from(roles),
//       roleToChannelsMap: roleToChannels,
//     };
//   }, [data]);

//   return (
//     <table className="table-auto border-collapse w-full text-center">
//       <thead>
//         <tr>
//           <th rowSpan={2} className="border p-1 bg-[#E5F6F6]">
//             Sidebar
//           </th>
//           {rolesArray.map((role, roleIndex) => (
//             <th
//               key={role}
//               colSpan={roleToChannelsMap[role].length}
//               className={`border p-2 ${bgColors[roleIndex % bgColors.length]}`}
//             >
//               {role}
//             </th>
//           ))}
//         </tr>
//         <tr>
//           {rolesArray.map((role, roleIndex) =>
//             roleToChannelsMap[role].map((channel) => (
//               <th
//                 key={`${role}-${channel}`}
//                 className={`border p-2 ${subColumnColors[roleIndex % subColumnColors.length]}`}
//               >
//                 {channel}
//               </th>
//             )),
//           )}
//         </tr>
//       </thead>
//       <tbody>
//         {data.map((group, groupIndex) => (
//           <React.Fragment key={groupIndex}>
//             <tr>
//               <td className="bg-gray-100 border p-2 text-start font-semibold">
//                 {group.header}
//               </td>
//               {rolesArray.map((role, roleIndex) =>
//                 roleToChannelsMap[role].map((channel) => (
//                   <td
//                     key={`${group.header}-${role}-${channel}`}
//                     className={`border p-2 ${columnContentColors[roleIndex % columnContentColors.length]}`}
//                   ></td>
//                 )),
//               )}
//             </tr>

//             {group.sidebars.map((sidebar, i) => (
//               <tr key={i}>
//                 <td className=" border p-2 text-start">
//                   {sidebar.sidebar}
//                 </td>

//                 {rolesArray.map((role, roleIndex) =>
//                   roleToChannelsMap[role].map((channel) => {
//                     const cell = sidebar?.[role]?.[channel];
//                     return (
//                       <td
//                         key={`${group.header}-${role}-${channel}-${i}`}
//                         className={`border p-2 ${columnContentColors[roleIndex % columnContentColors.length]}`}
//                       >
//                         {cell?.show ? 'test' : '-'}
//                       </td>
//                     );
//                   }),
//                 )}
//               </tr>
//             ))}
//           </React.Fragment>
//         ))}
//       </tbody>
//     </table>
//   );
// };
// const Communicationinfo = () => {
//   const methods = useForm({
//     defaultValues: {},
//     mode: 'all',
//   });
//   const { handleSubmit, setValue, control, setError, watch } = methods;

//   const [messageApi, messageContextHolder] = message.useMessage();
//   const { fields, replace } = useFieldArray({
//     control,
//     name: 'masterKey.communcations', // unique name for your Field Array
//   });

//   const dynamicArray = [
//     {
//       header: 'Jobs',
//       sidebars: [
//         {
//           sidebar: 'job posting and approval',
//           candidate: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//           hr: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//           interviewer: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//         },
//         {
//           sidebar: 'job not approved',
//           candidate: { email: { show: false, enabled: true } },
//           hr: {
//             email: { show: true, enabled: false },
//             interviewer: { email: { show: true, enabled: true } },
//           },
//         },
//       ],
//     },
//     {
//       header: 'Candidates',
//       sidebars: [
//         {
//           sidebar: 'Welcome',
//           candidate: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//           hr: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//           interviewer: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//           },
//         },
//         {
//           sidebar: 'interview scheduled',
//           candidate: {
//             email: { show: false, enabled: true },
//             sms: { show: true, enable: false },
//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//           hr: {
//             email: { show: false, enabled: true },

//             WhatsApp: { show: false, enabled: true },
//             call: { show: true, enable: false },
//           },
//         },
//       ],
//     },
//   ];
//   useEffect(() => {
//     if (isEmpty(dynamicArray)) return;

//     setValue('masterKey', {
//       communcations: dynamicArray,
//     });
//     replace(dynamicArray);

//     return () => {
//       setValue('masterKey', {});
//       replace([]);
//     };
//   }, []);
//   console.log('testsfields', fields);
//   const onSubmit = () => {};
//   // const extractRolesAndChannels = (data: typeof dynamicArray) => {
//   //   const roles = new Set<string>();
//   //   const channels = new Set<string>();

//   //   data.forEach((group) => {
//   //     group.sidebars.forEach((sidebar) => {
//   //       Object.keys(sidebar).forEach((key) => {
//   //         if (key === 'sidebar') return;
//   //         roles.add(key);
//   //         const roleObj = sidebar[key as keyof typeof sidebar];
//   //         if (typeof roleObj === 'object') {
//   //           Object.keys(roleObj).forEach((channel) => {
//   //             channels.add(channel);
//   //           });
//   //         }
//   //       });
//   //     });
//   //   });

//   //   return {
//   //     roles: Array.from(roles),
//   //     channels: Array.from(channels),
//   //   };
//   // };
//   // const { roles, channels } = extractRolesAndChannels(dynamicArray);
//   return (
//     <div className="w-full">
//       {reactQueryLoadingHelper(
//         <div className="h-96 flex items-center justify-center">
//           <Spin />
//         </div>,
//         <div className="h-96 flex items-center justify-center">
//           {DEFAULT_ERROR_MESSAGE}
//         </div>,
//         <FormProvider {...methods}>
//           <form onSubmit={handleSubmit(onSubmit)}>
//             <div className="w-full h-[90vh] overflow-y-auto pb-5 scrollbar-none bg-white mt-6">
//               <CommunicationTable data={dynamicArray} />
//             </div>
//           </form>
//         </FormProvider>,
//       )}
//     </div>
//   );
// };
// export default Communicationinfo;
import { message, Spin } from 'antd';
import Checkbox from 'Components/CommonComponents/ReactHooKForm/Checkbox/Checkbox';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import {
  FormProvider,
  useFormContext,
  useFieldArray,
  useForm,
  useWatch,
} from 'react-hook-form';
import 'Styles/AddProfileAndRole.scss';
import Button from 'Components/CommonComponents/Button/Button';
import {
  useActivateCommunications,
  useGetCommunicationActivations,
} from 'ServiceHooks/communicationHooks';
import { DEFAULT_ERROR_MESSAGE } from 'Utilities/constants';
const CommunicationTable = ({ name, fields }) => {
  const subColumnColors = [
    'bg-[#D9FBFF]',
    'bg-[#F8E5FF]',
    'bg-[#EEEEEE]',
    'bg-[#FFF2D1]',
    'bg-[#CEEAFF]',
    'bg-[#D8FBAC]',
    'bg-[#FFE0CF]',
  ];
  const headerNames = ['email', 'sms', 'whatsapp', 'voice_bot'];
  const columnContentColors = [
    'bg-[#E9FDFF]',
    'bg-[#FCF3FF]',
    'bg-[#F9F9F9]',
    'bg-[#FFF7EC]',
    'bg-[#ECF7FF]',
    'bg-[#F0FFDD]',
    'bg-[#FFF3EC]',
  ];
  const { control } = useFormContext();

  // const { fields } = useFieldArray({
  //   control,
  //   name: name, // unique name for your Field Array
  // });
  console.log('fieldds', fields);

  const headers = headerNames.map((name, index) => (
    <th key={`header-${index}`}>{name}</th>
  ));
  console.log('data', headers);

  return (
    <div className="w-full h-[90%] overflow-auto">
      <table className="table-auto border-collapse w-full text-center border border-[#DADADA]">
        <thead className="sticky top-0 z-10 bg-white">
          <tr>
            <th
              rowSpan={1}
              className="w-[40%] font-medium border border-[#DADADA] text-left p-1 pl-4 bg-[#E5F6F6]"
            >
              Transactions
            </th>
            {headerNames.map((role, roleIndex) => (
              <th
                key={role}
                colSpan={1}
                className={`border font-medium  p-2 ${subColumnColors[roleIndex % subColumnColors.length]}`}
              >
                {role
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase())}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {fields.map((group, groupIndex) => {
            const transactions = group.transactions || [];

            if (transactions.length === 0) {
              return (
                <tr key={`group-${groupIndex}`} className="hidden" /> // or return null
              );
            }

            return (
              <React.Fragment key={`group-${groupIndex}`}>
                <tr key={`group-${groupIndex}`}>
                  <td className="font-medium border border-[#DADADA] text-left p-1 pl-4 bg-[#F0F6F6]">
                    {group.header}
                  </td>
                  {headerNames.map((_, index) => (
                    <td
                      key={`empty-${groupIndex}-${index}`}
                      className={`border text-center border-[#DADADA]  ${columnContentColors[index % columnContentColors.length]}`}
                    ></td>
                  ))}
                </tr>
                {transactions?.map((transaction, tIndex) => (
                  <tr key={`transaction-${groupIndex}-${tIndex}`}>
                    <td className="font-normal border border-[#DADADA] text-left  pl-4 bg-white">
                      {transaction.sidebar}
                    </td>

                    {headerNames?.map((columnKey, index) => {
                      const fieldName = `masterKey.communcations[${groupIndex}].transactions[${tIndex}].${columnKey}.enabled`;
                      const show = transaction[columnKey]?.show;
                      const bgColorClass =
                        columnContentColors[
                          index % columnContentColors.length
                        ];

                      return (
                        <td
                          key={`group-empty-${index}`}
                          className={`border text-center border-[#DADADA] ${bgColorClass}`}
                        >
                          {show ? (
                            <div className="customCheckboxBorder customHeightCheckox pt-[1px]">
                              <Checkbox
                                name={fieldName}
                                control={control}
                                className=""
                                // defaultValue={
                                //   transaction[columnKey]?.enabled || false
                                // }
                                withCustomContent
                              />
                            </div>
                          ) : (
                            '-'
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
const Communicationinfo = () => {
  const {
    data: transcationList,
    status: transcationStatus,
    isLoading,
    isFetching,
  } = useGetCommunicationActivations({
    paramsData: {},
  });
  console.log('transcationList', transcationList);

  // const dynamicArray = [
  //   {
  //     header: 'Jobs',
  //     transactions: [
  //       {
  //         sidebar: 'Job posting and approval',
  //         email: { show: true, enabled: true },
  //         sms: { show: true, enabled: true },
  //         whatsapp: { show: true, enabled: false },
  //         voice_bot: { show: false, enabled: false },
  //       },
  //       {
  //         sidebar: 'Job creation',
  //         email: { show: true, enabled: true },
  //         sms: { show: true, enabled: true },
  //         whatsapp: { show: false, enabled: false },
  //         voice_bot: { show: true, enabled: false },
  //       },
  //     ],
  //   },
  //   {
  //     header: 'Candidates',
  //     transactions: [
  //       {
  //         sidebar: 'Candidate interview scheduled',
  //         email: { show: true, enabled: true },
  //         sms: { show: true, enabled: true },
  //         whatsapp: { show: true, enabled: false },
  //         voice_bot: { show: true, enabled: false },
  //       },
  //       {
  //         sidebar: 'Candidate rejected',
  //         email: { show: true, enabled: true },
  //         sms: { show: true, enabled: true },
  //         whatsapp: { show: true, enabled: false },
  //         voice_bot: { show: true, enabled: false },
  //       },
  //     ],
  //   },
  // ];
  const methods = useForm({
    defaultValues: {},
    mode: 'all',
  });
  const { handleSubmit, setValue, control, setError, watch } = methods;

  const [messageApi, messageContextHolder] = message.useMessage();
  const { fields, replace } = useFieldArray({
    control,
    name: 'masterKey.communcations', // unique name for your Field Array
  });
  useEffect(() => {
    if (isEmpty(transcationList)) return;
    // if (transcationStatus === 'success' && !isEmpty(transcationList)) {
    //   setValue('masterKey', {
    //     communcations: transcationList,
    //   });
    //   replace(transcationList);
    // }

    // return () => {
    //   setValue('masterKey', {});
    //   replace([]);
    // };
    setValue('masterKey', {
      communcations: transcationList,
    });
    replace(transcationList);

    return () => {
      setValue('masterKey', {});
      replace([]);
    };
  }, [transcationList, setValue, replace]);

  console.log('fields', fields);
  const { mutate: activatePermissions, isLoading: isCreating } =
    useActivateCommunications({
      onSuccess: async (data, variables, context) => {
        await messageApi.open({
          type: 'success',
          content: 'Successfully persimssions are updated',
        });
      },
      onError: async (error) => {
        console.error('Creation Error:', error);
        const message = error?.response?.data?.error_info;

        messageApi.open({
          type: 'error',
          content: message || DEFAULT_ERROR_MESSAGE,
        });
      },
    });
  const onSubmit = (data) => {
    const payload = data.masterKey.communcations;
    console.log('Form data:', payload);
    activatePermissions(payload);
  };
  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="">
          <div className="w-full h-[80vh] overflow-y-auto pb-5 scrollbar-none mt-10">
            {transcationStatus === 'loading' && (
              <div className="flex justify-center items-center ">
                <Spin
                  size="large"
                  // tip="Loading communication settings..."
                />
              </div>
            )}
            {transcationStatus === 'success' && !isEmpty(fields) && (
              <>
                <CommunicationTable
                  name={`masterKey.communcations`}
                  fields={fields}
                />

                <div className="flex justify-end pt-6">
                  {messageContextHolder}
                  <Button
                    className="py-2 px-8 text-sm font-semibold"
                    htmlType="submit"
                    type="primary"
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
export default Communicationinfo;
